import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-card',
  templateUrl: './card-wrapper.component.html',
})
export class CardWrapperComponent extends FieldWrapper {
}
